export enum SubmitStageStatus {
  INITIAL,
  PROCESSING,
  SUCCESS,
  ERROR
}

export enum SubmitStageStep {
  STEP_1 = 1,
  STEP_2 = 2,
  STEP_3 = 3,
  STEP_4 = 4,
  STEP_5 = 5
}

export type SubmitStageProp = {
  step: number | null
  status: SubmitStageStatus | null
  error?: string | null
}

export type SubmitStage = {
  step: number
  status: SubmitStageStatus | null
  message: string
  icon?: JSX.Element
  error?: string | null
}
